/*
 *  I08CALCVOLEXPCalcul.js
 *
 *  Created by Sébastien Hecart on 2017-12-11 12:07:43 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

import { I08CALCVOLEXP_State } from '@batical/types/src'

const sliderValue = [0.0004, 0.0018, 0.0044, 0.0079, 0.0121, 0.0171, 0.0228, 0.0296, 0.0321, 0.0359, 0.0434, 0.0516]
const sliderLabel = [10, 20, 30, 40, 50, 60, 70, 80, 85, 90, 100, 110]

function I08CALCVOLEXP_docalcul(state: I08CALCVOLEXP_State) {
  state.invalidated = false
  const facteurExpansion = sliderValue[sliderLabel.findIndex(x => x === state.in_temperature)]
  if (state.pickerSelected === '1') {
    state.in_pressionRefoulement = 0.0
  }
  const res_volumeExpansionEau = state.in_volEauRet * facteurExpansion
  const res_volumeReserve = state.in_volEauRet / 100
  const res_volumeNet = res_volumeReserve + res_volumeExpansionEau

  state.res_pressionGonflage = state.in_hauteurInstallation / 10 + 0.3
  let pressGon2 = state.in_pressionMin
  if (pressGon2 > state.res_pressionGonflage) {
    state.res_pressionGonflage = pressGon2
  }
  if (state.res_pressionGonflage < 0.5) {
    state.res_pressionGonflage = 0.5
  }
  if (state.pickerSelected === '1') {
    state.res_pressionMax = state.in_pressionSoupape
  } else {
    state.res_pressionMax = state.in_pressionSoupape + state.in_hauteurVase / 10 - state.in_pressionRefoulement
  }
  state.res_pressionFinal = state.res_pressionMax - 0.5

  state.res_facteurPression = (state.res_pressionFinal - state.res_pressionGonflage) / (state.res_pressionFinal + 1)
  if (state.res_facteurPression <= 0) {
    //risque de DIVISION PAR ZERO
    state.res_volumeVaseExpansion = 0
    state.res_volumeReserve2 = 0
    state.res_pressionInitialVase = 0
  } else {
    state.res_volumeVaseExpansion = res_volumeNet / state.res_facteurPression
    state.res_volumeReserve2 = state.res_facteurPression * state.in_volumVaseChoisit - res_volumeExpansionEau
    state.res_pressionInitialVase =
      (state.in_volumVaseChoisit * (state.res_pressionGonflage + 1)) / (state.in_volumVaseChoisit - state.res_volumeReserve2) - 1
    //Pini = ( ( Volvc *  (Pgon +1) ) / (Volvc - Volres))  - 1
  }
  return state
}

export default I08CALCVOLEXP_docalcul
